import { useState, useEffect } from 'react'
import { ethers } from 'ethers'

export const publicSaleDetails = (contractAddress, abi, context) => {
  const [userPublicSaleBalance, setUserPublicSaleBalance] = useState(0)
  const [publicSaleCount, setPublicSaleCount] = useState(0)

  useEffect(() => {
    fetchPublicSaleCount()
  }, [])

  // Calling this function inside useEffect to fetch balance on component load
  useEffect(() => {
    fetchPublicSaleBalance()
  }, [context.address])

  // useEffect(() => {
  //   if (window?.ethereum) {
  //     const fetchInitialState = async () => {
  //       const provider = new ethers.BrowserProvider(window.ethereum)
  //       const signer = await provider.getSigner()
  //       const address = await signer.getAddress()
  //       const walletBalance = await provider.getBalance(address)
  //       context.setAddress(address)
  //       context.setBalance(ethers.formatEther(walletBalance))
  //       // Fetch and set the initial balance and address of user
  //     }

  //     fetchInitialState()
  //   }
  // }, [])

  const fetchPublicSaleBalance = async () => {
    const provider = new ethers.BrowserProvider(window.ethereum)
    const contract = new ethers.Contract(contractAddress, abi, provider)

    const balance = await contract.getPubBalance(context.address)
    console.log(balance)
    setUserPublicSaleBalance(ethers.formatEther(balance))
  }

  const fetchPublicSaleCount = async () => {
    const provider = new ethers.BrowserProvider(window?.ethereum)
    const contract = new ethers.Contract(contractAddress, abi, provider)

    const count = await contract?.publicsaleCount()
    setPublicSaleCount(ethers.formatEther(count))
  }

  return {
    userPublicSaleBalance,
    publicSaleCount,
    fetchPublicSaleBalance,
    fetchPublicSaleCount,
  }
}
